<script setup>
import VerseActionItems from './VerseActionItems.vue';
const emit = defineEmits(['updateFavoriteStatus']);
const props = defineProps({
    psalmIndex: { type: String, required: true },
    verseIndex: { type: Number, required: true },
    favoriteVerses: { type: Array, required: true }, // [1, 4, 6] ...
}); 

function updateHelper() {
      emit('updateFavoriteStatus');
}
</script>

<template>
    <div class="prose">
        <p class="prose-row" :class="[{ 'is-favorite': favoriteVerses.includes(verseIndex+1) }]"> 
            <span class="prose-number"><span>{{ verseIndex + 1 }}</span></span>
            <slot></slot>
            <VerseActionItems 
                @updateFavoriteStatus="updateHelper"
                :verse="verseIndex"
                :favoriteVerses="favoriteVerses"
                :canOpenView="true"
                ></VerseActionItems>
        </p>
    </div>
</template>